// GIS-188: the member app's origin, in one place. The event URL field and the
// QR screen used to derive it two different ways (one hardcoded, one guessed from
// window.location), and the SMS previews spelled it out a third time.
//
// REACT_APP_APP_ORIGIN overrides it for a staging build; unset, every string here
// is what the panel showed before. Two shapes, as the call sites used them: full
// URLs, and scheme-less "app.gistirl.com/..." (SMS copy and the QR code).

export const DEFAULT_APP_ORIGIN = "https://app.gistirl.com";

export function normalizeOrigin(value, fallback) {
  const raw = typeof value === "string" ? value.trim() : "";
  if (!raw) return fallback;
  const withScheme = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
  try {
    const { origin } = new URL(withScheme);
    return origin && origin !== "null" ? origin : fallback;
  } catch {
    return fallback;
  }
}

export function getAppOrigin(env = process.env) {
  return normalizeOrigin(env.REACT_APP_APP_ORIGIN, DEFAULT_APP_ORIGIN);
}

export const APP_ORIGIN = getAppOrigin();
/** "app.gistirl.com" */
export const APP_HOST = APP_ORIGIN.replace(/^https?:\/\//i, "");

/** https://app.gistirl.com<path> */
export const appUrl = (path = "") => `${APP_ORIGIN}${path}`;
/** app.gistirl.com<path>, no scheme. */
export const appBareUrl = (path = "") => `${APP_HOST}${path}`;
/** https://app.gistirl.com/event-details/<id> */
export const eventDetailsUrl = (eventId) => appUrl(`/event-details/${eventId}`);
/** app.gistirl.com/event-details/<id>, no scheme. */
export const eventDetailsBareUrl = (eventId) => appBareUrl(`/event-details/${eventId}`);
